module.exports = __webpack_public_path__ + "static/media/joe-biden.67eac539.jpg";